export type AppRoute =
  | { screen: "start" }
  | { screen: "reports" }
  | { screen: "account"; orderId?: string }
  | { screen: "delete-account" }
  | { screen: "information"; page: "privacy" | "terms" | "support" }
  | { screen: "rooms" }
  | { screen: "room"; roomId: string }
  | { screen: "issue"; roomId: string; issueId: string }
  | { screen: "review" }
  | { screen: "export" }
  | { screen: "admin" };

export function roomPath(roomId: string): string {
  return `/rooms/${encodeURIComponent(roomId)}`;
}

export function conditionNotePath(roomId: string, conditionNoteId: string): string {
  return `${roomPath(roomId)}/condition-notes/${encodeURIComponent(conditionNoteId)}`;
}

export function parseAppRoute(pathname: string): AppRoute {
  if (pathname === "/privacy" || pathname === "/terms" || pathname === "/support") return { screen: "information", page: pathname.slice(1) as "privacy" | "terms" | "support" };
  if (pathname === "/account/delete") return { screen: "delete-account" };
  if (pathname === "/account/reports") return { screen: "account" };
  const cloudReport = pathname.match(/^\/account\/reports\/([a-f0-9]{64})$/);
  if (cloudReport) return { screen: "account", orderId: cloudReport[1] };
  if (pathname === "/reports") return { screen: "reports" };
  if (pathname === "/" || pathname === "") {
    return { screen: "start" };
  }
  if (pathname === "/rooms") {
    return { screen: "rooms" };
  }
  if (pathname === "/review") {
    return { screen: "review" };
  }
  if (pathname === "/export") {
    return { screen: "export" };
  }
  if (pathname === "/admin") {
    return { screen: "admin" };
  }
  const conditionNoteMatch = pathname.match(/^\/rooms\/([^/]+)\/(?:condition-notes|issues)\/([^/]+)$/);
  if (conditionNoteMatch) {
    return {
      screen: "issue",
      roomId: decodeURIComponent(conditionNoteMatch[1]),
      issueId: decodeURIComponent(conditionNoteMatch[2])
    };
  }
  const roomMatch = pathname.match(/^\/rooms\/([^/]+)$/);
  if (roomMatch) {
    return { screen: "room", roomId: decodeURIComponent(roomMatch[1]) };
  }
  return { screen: "start" };
}
